import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DynamicListModule } from '../fw/dynamic-list/dynamic-list.module';
import { DynamicListService } from '../fw/dynamic-list/services';
import { HOM_ENVIRONMENT } from 'hom-lib/hom-environment';
import { HomHubReconnectService, HomHubService, HOM_HUB_USER_CONTEXT } from 'hom-lib/hom-hub';

import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { RefreshUserComponent } from './refresh-user/refresh-user.component';
import { SharedModule } from '../shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';

import * as fromAuth from './store/auth.reducer';
import { AuthGuard, UserPriviledgesService } from './services/index';
import { HomAppHubAdapter } from './services/hom-app-hub-adapter';
import { AuthEffects } from './store/auth.effects';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    SigninComponent,
    SignupComponent,
    RefreshUserComponent
  ],
  imports: [
    FormsModule, 
    CommonModule,
    SharedModule,
    DynamicListModule,
    AuthRoutingModule,
    StoreModule.forFeature('auth', fromAuth.authReducer),
    EffectsModule.forFeature([AuthEffects]),
    ReactiveFormsModule
  ],
  exports: [
    SigninComponent,
    SignupComponent,
    RefreshUserComponent
  ],
  providers: [
    DynamicListService
  ]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthGuard,
        UserPriviledgesService,
        HomHubService,
        HomHubReconnectService,
        HomAppHubAdapter,
        { provide: HOM_ENVIRONMENT, useValue: environment },
        {
          provide: HOM_HUB_USER_CONTEXT,
          useFactory: (ups: UserPriviledgesService) => ({
            subscriberType: 'ProviderUser' as const,
            currentUserId$: ups.currentUserId$
          }),
          deps: [UserPriviledgesService]
        }
      ]
    };
  }
}
